import "./styles/tokens.css";
import "./styles/app.css";

import { buyStars, claimDaily, copyRef, openSupport, shareRef } from "./actions";
import { getMuted, initAudioUnlock, loadMutePreference, setMuted } from "./audio";
import { countUp, drawSparkline, goTo, render } from "./render";
import { initSheen } from "./sheen";
import { initSquircles } from "./squircle";
import { state, loadUser } from "./state";
import { initTelegram, tg } from "./telegram/sdk";
import { initViewport } from "./telegram/viewport";

initTelegram();
initViewport();
initSheen();
initAudioUnlock();

loadUser();
render();
// PHASE 8: no-op on Chromium (native corner-shape), real work only on
// Safari/WebKit — the actual iOS Telegram in-app browser. Called after
// the first render() so initial elements exist to measure.
initSquircles();

// Loaded async (tg.CloudStorage round-trip) — the toggle in Settings
// starts in its markup default (off, matching the "default MUTED" rule)
// and is corrected once the user's real saved preference resolves.
loadMutePreference(tg).then(() => {
  document.getElementById("soundToggle")?.classList.toggle("on", !getMuted());
});

const balanceNode = document.getElementById("balanceNum");
if (balanceNode) {
  setTimeout(() => countUp(balanceNode, state.balance, 1100), 120);
}

window.addEventListener("resize", drawSparkline);

// ---------------------------------------------------------------- 3D (Phase 4, progressive enhancement)
// Lazy-loaded, never on the critical path for first paint (it starts after
// the shell has already rendered), and fault-tolerant: if this rejects for
// any reason, the Tier 1 CSS/SVG hero card is already fully shoppable and
// nobody sees a difference. See src/three/mount.ts.
import("./three/mount")
  .then(({ initCrystal }) => initCrystal("heroCrystal", tg))
  .catch(() => {
    // Intentionally silent — Tier 1 stays up, this is not a user-facing failure.
  });

// ---------------------------------------------------------------- nav

const handleNav = (target: string) => goTo(target, () => buyStars("premium", 500));

document.querySelectorAll<HTMLElement>("[data-nav]").forEach((btn) => {
  btn.addEventListener("click", () => handleNav(btn.dataset["nav"]!));
});

if (tg?.BackButton) {
  // "settings" is a sub-screen reached only from Profile (not one of the
  // 5 bottom-nav tabs) — back from it should return to Profile, not jump
  // to Home like it does from every top-level tab.
  tg.BackButton.onClick(() => {
    const current = document.querySelector<HTMLElement>(".screen.active")?.dataset["screen"];
    handleNav(current === "settings" ? "profile" : "home");
  });
}

document.getElementById("dailyBtn")?.addEventListener("click", claimDaily);

// ---------------------------------------------------------------- delegated actions
// PHASE 2: the pre-overhaul file used inline `onclick="fn(...)"` HTML
// attributes calling global functions. ES modules have no implicit global
// scope, so those attributes are gone from index.html — replaced with
// `data-action`/`data-*` attributes and one delegated listener here.
// Behavior at each call site is unchanged; only the wiring mechanism is.

document.getElementById("app")?.addEventListener("click", (event) => {
  const target = (event.target as HTMLElement).closest<HTMLElement>("[data-action]");
  if (!target) return;
  const action = target.dataset["action"];

  switch (action) {
    case "buy-stars": {
      const tariff = target.dataset["tariff"] ?? "";
      const amount = Number(target.dataset["amount"] ?? "0");
      buyStars(tariff, amount);
      break;
    }
    case "copy-ref":
      copyRef();
      break;
    case "share-ref":
      shareRef();
      break;
    case "open-support":
      openSupport();
      break;
    case "toggle-sound": {
      const nowOn = !target.classList.contains("on");
      target.classList.toggle("on", nowOn);
      setMuted(tg, !nowOn);
      break;
    }
  }
});
